<template>
	<cleave
		class="fts-form-control"
		v-model="model"
		:options="options"
		@blur="$emit('blur')"
	/>
</template>

<script>
import Vue from 'vue'
import Cleave from "vue-cleave-component";
Vue.use(Cleave);

import commons from '../commons/commons';

export default {
	props: {
		item: Object,
		formData: Object,
		value: Number,
		numeralIntegerScale: {
			type: Number,
			default: 12,
		},
		numeralDecimalScale: Number,
		numeralPositiveOnly: Boolean,
	},
	model: {
    prop: "value",
    event: "updateValue",
  },
	components: {
		Cleave,
	},
	computed: {
		model: {
			get() {
				// let model = this.formData[this.item.fieldName]
				// if (model) {
				// 	return this.item.decimalPlaces ? 
				// 		parseFloat(parseFloat(model).toFixed(this.item.decimalPlaces)) : 
				// 		parseFloat(parseFloat(model).toFixed(2))
				// } else {
				// 	return model
				// } 
				/* item.fieldName */
				if (this.item && this.item.fieldName) {
					return this.formData[this.item.fieldName];
				}
				/* value */
				else {
					return this.value;
				}
			},
			set(val) {
				const res = commons.isNumber(val) ? parseFloat(val) : null;
				/* item.fieldName */
				if (this.item && this.item.fieldName) {
					this.$set(this.formData, this.item.fieldName, res);
				} 
				/* value */
				else {
					this.$emit('updateValue', val);
				}
				this.$emit('input', res);
			}
		},
		options() {
			const numeralDecimalScale = commons.isInteger(this.numeralDecimalScale) ? 
				this.numeralDecimalScale : this.item && this.item.decimalPlaces;
			
			/* type 4, money only 2 decimal places */
			const options = {
				numeral: true,
				numeralIntegerScale: this.numeralIntegerScale,
				numeralPositiveOnly: this.numeralPositiveOnly,
			}
			if (
				commons.isInteger(numeralDecimalScale) && 
				(!this.item || (this.item && this.item.type !== 4))
			) {
				return { 
					...options,
					numeralDecimalScale: numeralDecimalScale,
				}
			} else {
				return options;
			}
		},
	},
}
</script>